import { LoginStore } from "pages/LoginPage/store/LoginStore";
import HeaderStore from "./HeaderStore";
import SnackbarStore from "./SnackbarStore";

class RootStore {
  loginStore: LoginStore;
  headerStore: HeaderStore;
  snackbarStore: SnackbarStore;

  constructor() {
    this.loginStore = new LoginStore();
    this.headerStore = new HeaderStore();
    this.snackbarStore = new SnackbarStore();
  }
}
export default RootStore;
